import { render } from "./Skeleton.vue?vue&type=template&id=6730c3b0&ts=true"
import script from "./Skeleton.vue?vue&type=script&lang=ts"
export * from "./Skeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__